import { inject } from "vue";
import { Properties } from "acquaint-api/models/Properties";
import { AcquaintApiClient } from "@/services/AcquaintApiClient";
import displayErrorMessage from "@/utils/ErrorHandling";
import { getErrorMessage } from "bright-logic-core/src/errors";
import { PropertySummary } from "@/types/properties/PropertySummary";

export function usePropertyHelper() {
  const acquaintApiClient = inject<AcquaintApiClient>("AcquaintApiClient")!;

  return {
    fetchPropertyById: async (propertyId: number) => {
      try {
        if (propertyId > 0) {
          const property = await acquaintApiClient.httpGet<Properties>(
            `database/properties/${propertyId}`,
          );
          return property;
        }
      } catch (ex) {
        displayErrorMessage(getErrorMessage(ex));
      }
    },
    fetchPropertyDataSummary: async (propertyId: number) => {
      try {
        return await acquaintApiClient.httpGet<PropertySummary>(
          `app/properties/${propertyId}/summary`,
        );
      } catch (err) {
        displayErrorMessage(getErrorMessage(err));
      }
    },
  };
}
